import QnAdCard from "@components/Modules/QuickNews/Cards/QnAdCard";
import QnArticleCard from "@components/Modules/QuickNews/Cards/QnArticleCard";
import { QnEndCard } from "@components/Modules/QuickNews/Cards/QnEndCard";
import { QnQuizCard } from "@components/Modules/QuickNews/Cards/QnQuizCard";
import QnVideoCard from "@components/Modules/QuickNews/Cards/QnVideoCard";
import { FeedItem, VideoItem } from "@typings/QuickNews";

type FeedRenderProps = {
  card: FeedItem;
  isMobile: boolean;
  nextCard: () => void;
  getOlderArticles: () => void;
  typeIndex: number;
  isActive: boolean;
};

type VideoRenderProps = {
  card: VideoItem;
  index: number;
  isMute: boolean;
  setIsMute: (mute: boolean) => void;
  activeTab: string;
  videoIndex: number;
};

export const renderFeedCard = ({
  card,
  isMobile,
  nextCard,
  getOlderArticles,
  typeIndex,
  isActive,
}: FeedRenderProps) => {
  if ("quizzes" in card) return <QnQuizCard key={card.id} item={card} />;
  if ("adType" in card)
    return (
      <QnAdCard
        key={card.id}
        item={card}
        onNext={nextCard}
        isMobile={isMobile}
        isActive={isActive}
      />
    );
  if ("endCard" in card)
    return (
      <QnEndCard
        key={card.id}
        item={card}
        feedType="MyFeed"
        getOlderArticles={getOlderArticles}
      />
    );
  return (
    <div className="w-full h-full m-auto overflow-hidden">
      <QnArticleCard item={card} typeIndex={typeIndex} isMobile={isMobile} />
    </div>
  );
};

export const renderVideoCard = ({
  card,
  index,
  isMute,
  setIsMute,
  activeTab,
  videoIndex,
}: VideoRenderProps) => {
  if ("endCard" in card)
    return <QnEndCard key={card.id} item={card} feedType="Videos" />;
  return (
    <QnVideoCard
      key={card.id}
      bcVideo={card}
      isMute={isMute}
      setIsMute={setIsMute}
      isActive={activeTab === "Videos" && index === videoIndex}
      videoIndex={videoIndex}
    />
  );
};
